'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _EntypoIcon = require('../EntypoIcon');

var _EntypoIcon2 = _interopRequireDefault(_EntypoIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var iconClass = 'entypo-svgicon entypo--Googleplus';

var EntypoGoogleplus = function EntypoGoogleplus(props) {
    return _react2.default.createElement(
        _EntypoIcon2.default,
        _extends({ propClass: iconClass }, props),
        _react2.default.createElement('path', { d: 'M1.989,5.589c0,1.494,0.499,2.572,1.482,3.205c0.806,0.52,1.74,0.598,2.226,0.598c0.118,0,0.213-0.006,0.279-0.01c0,0-0.154,1.004,0.59,1.996H6.532c-1.289,0-5.493,0.269-5.493,3.727c0,3.516,3.861,3.695,4.636,3.695c0.061,0,0.097-0.002,0.097-0.002c0.008,0,0.063,0.002,0.158,0.002c0.497,0,1.782-0.062,2.975-0.643c1.548-0.75,2.333-2.059,2.333-3.885c0-1.764-1.196-2.814-2.069-3.582c-0.533-0.469-0.994-0.873-0.994-1.266c0-0.4,0.337-0.701,0.762-1.082c0.689-0.615,1.339-1.492,1.339-3.15c0-1.457-0.189-2.436-1.354-3.057c0.121-0.062,0.551-0.107,0.763-0.137c0.631-0.086,1.554-0.184,1.554-0.699V1.2H6.64C6.594,1.202,1.989,1.372,1.989,5.589z M9.413,14.602c0.088,1.406-1.115,2.443-2.922,2.574c-1.835,0.135-3.345-0.691-3.433-2.096c-0.043-0.676,0.254-1.336,0.835-1.863c0.589-0.533,1.398-0.863,2.278-0.928c0.104-0.006,0.207-0.012,0.31-0.012C8.18,12.278,9.33,13.276,9.413,14.602z M8.212,4.626c0.451,1.588-0.23,3.246-1.316,3.553C6.771,8.214,6.643,8.231,6.512,8.231c-0.994,0-1.979-1.006-2.345-2.393C3.963,5.062,3.98,4.38,4.214,3.726c0.229-0.645,0.643-1.078,1.163-1.225c0.125-0.035,0.254-0.053,0.385-0.053C6.962,2.448,7.734,2.946,8.212,4.626z M16,8V5h-2v3h-3v2h3v3h2v-3h3V8H16z' })
    );
};

exports.default = EntypoGoogleplus;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-entypo-icons/lib/entypo/Googleplus.js
// module id = 609
// module chunks = 168707334958949